<template>
    <div class="banner-popup" v-if="isShow">
        <h1 class="banner-popup--title" v-html="title"></h1>
        <p class="banner-popup--content" v-html="content"></p>
        <div class="banner-popup--close"  @click="closeBanner()"></div>
    </div>
</template>

<script>
export default {
    name: "PopupHome",
    data() {
        return {
            title: '',
            content: '',
            isShow: true
        }
    },
    methods: {
        closeBanner() {
            this.isShow = false
        }
    },
    mounted() {
        this.$api.getBannerHome()
            .then((resp) => {
                const data = resp.data.data
                this.title = data.title
                this.content = data.body
            })
            .catch(error => console.log(error))
    }
}
</script>

<style lang="scss" scoped>
.banner-popup {
    background-color: white;
    padding: 34px 40px;
    border-radius: 30px;
    // width: 100%;
    max-width: 707px;
    margin: auto;
    position: relative;

    @media screen and (max-width: 991px) {
        padding: 1em;
    }
    &--title{
        padding-right: 50px;
    }

    .banner-popup--close {
        position: absolute;
        top: 27px;
        right: 27px;
        font-size: 36px;
        font-weight: bold;
        cursor: pointer;

        &::before {
            content: "";
            display: block;
            background: url('@/assets/images/close\ icon.png') no-repeat center;
            width: 20px;
            height: 20px;
        }
    }
}
</style>